import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledSurvey = styled.div`
  margin: ${pxToRem(20)};
`
